// src/SfbContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../config';

const SfbContext = createContext();

export function SfbProvider({ children }) {
  const currentYear = new Date().getFullYear();

  const [sfb, setSfb] = useState([]);
  const [currentYearBalance, setCurrentYearBalance] = useState([]);
  const [sfbloading, setSfbLoading] = useState(false);

  const fetchData = async () => {
    try {
      setSfbLoading(true);
      //All Balance
      const response = await fetch(`${config.apiBaseUrl}/payments/getBalances.php`); // Production

      //Current Year Balance
      // const response = await fetch(`${config.apiBaseUrl}/payments/currentYearBalance.php`);
      
      const data = await response.json();
      
      setSfb(data);

      // Ensure filtering works correctly for datetime format
      const filteredBalance = data.filter(balance => 
        new Date(balance.server_date).getFullYear() === currentYear
      );
      setCurrentYearBalance(filteredBalance);

    } catch (error) {
      console.error('Error fetching fee balance data:', error);
    } finally {
      setSfbLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const refetchSfbData = () => {
    fetchData();
  };

  return (
    <SfbContext.Provider value={{ sfb, currentYearBalance, sfbloading, refetchSfbData }}>
      {children}
    </SfbContext.Provider>
  );
}

export function useSfb() {
  const context = useContext(SfbContext);
  if (!context) {
    throw new Error('useSfb must be used within a SfbProvider');
  }
  return context;
}
